import React from 'react';
import { pressLogos } from '../data/mock';

const PressMarquee = () => {
  return (
    <section className="bg-[#F5EDDD] border-y border-[#C9B596] py-7 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 flex items-center gap-6">
        <p className="shrink-0 text-[11px] tracking-[0.3em] uppercase text-[#A07A4F]">
          As seen in
        </p>
        <div className="flex-1 overflow-hidden relative">
          <div className="flex whitespace-nowrap marquee-track">
            {Array.from({ length: 2 }).map((_, j) => (
              <div key={j} className="flex shrink-0 items-center">
                {pressLogos.map((logo, i) => (
                  <span
                    key={i}
                    className="px-10 text-2xl md:text-3xl text-[#33200F]/85 tracking-wide"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    {logo}
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PressMarquee;
